export const Routes = {
  // GENERIC
  getin: {
    path: "/getin/:id",
    clean: "/getin/",
  },

  AdminUsers: { path: "/admin/users" },
  AdminOrganizations: { path: "/admin/organizations" },
  SignIn: { path: "/signin" },
  ForgotPassword: { path: "/forgotPassword" },
  Register: { path: "/register" },
  Home: { path: "/" },
  CheckProfile: { path: "/checkProfile" },

  NotFound: { path: "/examples/NotFound" },
  ServerError: { path: "/examples/ServerError" },
  Chat: { path: "/Chat" },
  Settings: { path: "/Settings/:id?", clean: "/Settings/" },
  Reports: { path: "/reports/:id" },
  Profile: { path: "/profile" },
  Search: { path: "/search" },
  Employees: { path: "/employees" },
  Georeferences: { path: "/georeferences" },
  LaborAccessRequest: { path: "/ValidationOfLaborRepresentative" },
  OwnerRequestControl: { path: "/ownerRequestControl" },
  EmployeeRequestControl: { path: "/employeeRequestControl" },
  RequestControl: { path: "/RequestControl" },

  LaborAccessRequestExternal: { path: "/externalLaborAccessRequest/:id" },
  CreateLaborAccessRequest: { path: "/createLaborAccessRequest" },
  LaborAccessRequestValidation: { path: "/laborAccessRequestValidation" },

  LaborAccessRequestProvider: { path: "/laborAccessRequestProvider" },
  Complains: { path: "/complains" },
  Incidents: { path: "/incidents" },
  Alerts: { path: "/alerts" },

  SelectOrganization: { path: "/SelectOrganization" },
  Record: { path: "/Record/:id", clean: "/Record/" },
  Dataworkerhome: { path: "/Dataworkerhome", clean: "/Dataworkerhome/" },

  Admin: { path: "/Admin/:id?", clean: "/Admin/" },
  Projects: { path: "/destinations", clean: "/destinations/" },
  Dashboard: { path: "/Dashboard", clean: "/Dashboard/" },
  DashboardProjectDetails: { path: "/Dashboard/:id", clean: "/Dashboard/" },
  LaborAccessRequestProviderExternal: {
    path: "/externaProviderLaborAccessRequest/:id",
    clean: "/externaProviderLaborAccessRequest/",
  },
  ValidationOfLaborRepresentative: {
    path: "/ValidationOfLaborRepresentative/",
    clean: "/ValidationOfLaborRepresentative/",
  },
  BackgroundCheckPage: {
    path: "/BackgroundCheck",
    clean: "/BackgroundCheck/",
  },
  PersonalPage: {
    path: "/personal",
    clean: "/personal/",
  },
  BackgroundCheckLanding: {
    path: "/corporate/background-check",
    clean: "/corporate/background-check/",
  },
  DataworkerLanding: {
    path: "/corporate/dataworker",
    clean: "/corporate/dataworker/",
  },
  BackgroundCheckReport: {
    path: "/bcr/:id",
    clean: "/bcr/",
  },
}
